type SignedUploadTarget = {
  storage_method?: string | null;
  upload_url?: string | null;
  upload_method?: string | null;
  upload_headers?: { [key: string]: unknown } | null;
};

function toHeaders(uploadHeaders: SignedUploadTarget['upload_headers']) {
  const headers: Record<string, string> = {};
  for (const [name, value] of Object.entries(uploadHeaders ?? {})) {
    headers[name] = String(value);
  }
  return headers;
}

/**
 * Sends a file straight to the storage behind a pre-signed upload url, the
 * way keyframes are uploaded. Plain fetch keeps the API client's auth headers
 * off the storage request.
 */
export async function uploadToSignedUrl(
  target: SignedUploadTarget,
  body: Blob,
): Promise<void> {
  if (!target.upload_url) {
    throw new Error('The storage did not return an upload url');
  }

  const headers = toHeaders(target.upload_headers);
  let response: Response;
  if (target.storage_method === 'GCS') {
    const session = await fetch(target.upload_url, {
      method: 'POST',
      headers: { ...headers, 'x-goog-resumable': 'start' },
    });
    const location = session.headers.get('location');
    if (!session.ok || !location) {
      throw new Error(`Upload session failed with status ${session.status}`);
    }
    response = await fetch(location, { method: 'PUT', body });
  } else {
    if (target.storage_method === 'AZURE') {
      headers['x-ms-blob-type'] = 'BlockBlob';
    }
    response = await fetch(target.upload_url, {
      method: target.upload_method ?? 'PUT',
      headers,
      body,
    });
  }

  if (!response.ok) {
    throw new Error(`Upload failed with status ${response.status}`);
  }
}
